export const EVENT_NAME_MAX_LENGTH = 40;

export const formatEventName = (eventName: string): string => {
  return eventName.split(' ').join('_').substring(0, EVENT_NAME_MAX_LENGTH);
};
